import React, { useState } from 'react';
import { Modal } from 'src/components/Modal/Modal';
import { SizesForm } from 'src/components/ProductDetail/SizesForm';
import { SizeGuideLoader } from 'src/components/SizeGuide/SizeGuideLoader';
import { Size as BundleSize } from 'src/components/ProductDetail/ProductSizes';
import { SwatchCss } from 'src/components/ProductDetail/utils/swatchData';

import { ModalHeader } from '../ProductDetail/ModalHeader';

import { ColorAndSize, Size } from './types';
import classes from './ProductBundle.scss';

type Props = {
    isOpenSizeQuantitiesModal: boolean;
    closeSizeQuantitiesModal: () => void;
    colorId: number;
    initialValues: Pick<ColorAndSize, 'sizes'>;
    handleSubmit: (values: Size[]) => void;
    sizes: BundleSize[];
    swatchCss: SwatchCss;
    sizeGuide: string;
    imageUrl?: string;
    maxQty: number;
    currentQty: number;
    title: string;
};

export const ModalSizeQuantities: React.FC<Props> = ({
    isOpenSizeQuantitiesModal,
    closeSizeQuantitiesModal,
    colorId,
    initialValues,
    handleSubmit,
    sizes,
    swatchCss,
    sizeGuide,
    imageUrl,
    maxQty,
    currentQty,
    title,
}) => {
    const [predictedQty, setPredictedQty] = useState(currentQty);

    const counter = `${predictedQty}/${maxQty}`;

    const handlePredictedQtyChange = (computedSizes) => {
        const initialValuesQty = initialValues.sizes.reduce((sum, { quantity }) => sum + quantity, 0);
        const newQty = computedSizes.reduce((sum, { quantity }) => sum + quantity, currentQty);

        setPredictedQty(newQty - initialValuesQty);
    };

    const closeModal = () => {
        closeSizeQuantitiesModal();
    };

    return (
        <Modal
            className={classes.productInformation}
            type={imageUrl ? 'wide' : 'popup'}
            isOpen={isOpenSizeQuantitiesModal}
            onDismiss={closeModal}
        >
            <ModalHeader
                title={title}
                closeModal={closeModal}
                swatchCss={swatchCss}
                counter={counter}
                maxQty={maxQty}
                predictedQty={predictedQty}
            />
            {sizeGuide && (
                <div className={classes.sizing}>
                    <SizeGuideLoader sizeGuide={sizeGuide} />{' '}
                </div>
            )}
            <div className={classes.formContainer}>
                {imageUrl && <img className={classes.image} src={imageUrl} alt={title} />}
                <SizesForm
                    initialValues={initialValues}
                    handleSubmit={handleSubmit}
                    sizes={sizes}
                    closeModal={closeModal}
                    colorId={colorId}
                    onSizeChange={handlePredictedQtyChange}
                />
            </div>
        </Modal>
    );
};
